import { $t } from '@gatherstar/utils/src/i18n';

export interface RouteConfig {
  path: string;
  title?: string;
  component?: string;
  layout?: boolean;
  hideInMenu?: boolean;
  icon?: string;
  redirect?: string;
  name?: string;
}

const routes: RouteConfig[] = [
  {
    layout: false,
    path: '/user/login',
    title: $t('登录'),
    component: './user/login',
    hideInMenu: true,
  },
  {
    path: '/',
    redirect: '/dashboard',
  },
  {
    path: '/dashboard',
    title: $t('首页'),
    component: './dashboard',
    icon: 'icon-home-roof',
  },
  {
    path: '/ad',
    title: $t('推广系列'),
    component: './ad',
    icon: 'icon-rocket'
  },
  {
    path: '/ad/form',
    title: $t('推广系列-广告创编'),
    component: './ad/form',
    hideInMenu: true,
  },
  {
    path: '/material-management',
    title: $t('素材管理'),
    component: './material-management',
    icon: 'icon-photos',
  },
  {
    path: '/asset-management',
    title: $t('资产管理'),
    component: './asset-management',
    icon: 'icon-d-box-top',
  },
  {
    path: '/asset-management/products-detail',
    title: $t('产品详情'),
    hideInMenu: true,
    component: './asset-management/product-detail',
  },
  {
    path: '/data-centers',
    component: './data-centers',
    title: $t('数据看板'),
    icon: 'ficon-a-chart-1statisticsflipchartpresentationgrap',
  },
  {
    path: '/finance-management',
    component: './finance-management',
    title: $t('财务管理'),
    icon: 'icon-wallet-3',
  },
  // {
  //   path: '/help-center',
  //   title: $t('帮助中心'),
  //   component: './coming-soon',
  //   icon: '',
  // },
  // {
  //   path: '/testPage',
  //   name: '',
  //   component: './testPage',
  //   hideInMenu: true,
  // },
  {
    path: '*',
    redirect: '/dashboard',
  },
];

export default routes;
